module.exports = __webpack_public_path__ + "img/img_49.275d0734.png";